import $ from 'jquery';

document.addEventListener( 'wpcf7mailsent', function( event ) {
    if (event.detail.contactFormId === 1272) {
        const fileURL = $('input[name="file"]').val();

        const a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = 'brochure.pdf'; 

        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();

        window.open(fileURL, '_blank');

        document.body.removeChild(a);
    }
});
